import { useLingui } from '@lingui/react/macro';
import { type FC, memo } from 'react';
import type { ResponseOf } from '@/backend';
import { Doc } from '@/docs/Doc';
import { useCoin } from '@/shared/api';
import { Widget } from '@/shared/Widget';

type CoinHTMLSectionProps = {
  content?: ResponseOf<'market-data:get:coin/{slug}/'>['contents'][number];
  loading?: boolean;
  heading?: string;
  slug?: string;
};

export const CoinHTMLSection: FC<CoinHTMLSectionProps> = memo(
  ({ content, loading, heading, slug }) => {
    const { t } = useLingui();
    const { data: coin } = useCoin(slug?.toUpperCase());

    return (
      <Widget
        loading={loading ?? false}
        className="space-y-4 border border-border-disabled rounded-xl"
      >
        {heading && (
          <h3 className="text-lg font-medium text-content-primary">
            {heading}
          </h3>
        )}
        {content ? (
          <Doc b64={content.data_base64} bind={coin || {}} />
        ) : (
          <p className="text-sm text-content-tertiary">
            {t`We are preparing this overview.`}
          </p>
        )}
      </Widget>
    );
  },
);
